import React from 'react'

import { DataAccessRequestQueryParameterSection } from 'modules/resultsV2/DataAccessRequestQueryParameterSection'
import * as styles from 'modules/resultsV2/ResultMeta.styles'
import {
  NO_RESTRICTION_APPLIED_MESSAGE,
  getDataAccessRequestQueryDisplayRows
} from 'modules/resultsV2/hooks/getDataAccessRequestQueryDisplayRows'
import type { DataAccessRequestQuerySource } from 'services/results/types'

export const TEST_ID_DATA_ACCESS_REQUEST_GENOTYPIC_QUERY = 'data-access-request-genotypic-query'

interface DataAccessRequestGenotypicQuerySectionProps {
  querySource?: DataAccessRequestQuerySource
}

export const DataAccessRequestGenotypicQuerySection = ({
  querySource
}: DataAccessRequestGenotypicQuerySectionProps): JSX.Element | null => {
  const { genotypicRows, isUnrestricted } = querySource
    ? getDataAccessRequestQueryDisplayRows(querySource)
    : { genotypicRows: [], isUnrestricted: false }

  const noRestrictionMessage = isUnrestricted ? NO_RESTRICTION_APPLIED_MESSAGE : undefined

  if (genotypicRows.length === 0 && !noRestrictionMessage) {
    return null
  }

  return (
    <styles.ItemRow>
      <styles.MetadataSection>
        <DataAccessRequestQueryParameterSection
          title="Genotypic query parameters"
          rows={genotypicRows}
          testId={TEST_ID_DATA_ACCESS_REQUEST_GENOTYPIC_QUERY}
          emptyMessage={noRestrictionMessage}
        />
      </styles.MetadataSection>
    </styles.ItemRow>
  )
}
